<template>
  <div class="listGroup">
    <div class="listGroup__listings">
      <div class="listview">
        <table>
          <thead class="none">
            <tr>
              <td></td>
              <td class="listview__title items">COLLECTION</td>
              <td class="listview__title placement">TOTAL LISTING</td>
              <td class="listview__title dailyvisitor">VISIBILITY</td>
              <td class="save"></td>
            </tr>
          </thead>
          <draggable v-if="type == `selected`" v-model="listItems" @end="onEnd" :element="'tbody'">
            <tr v-for="(item, index) in items" :key="index" @click.stop="listClick(item)" class="content">
              <td>
                <i class="adx-ic_arrow_drag"></i>
              </td>
              <td class="items">
                <div class="item">
                  <img v-if="item.square_thumbnail" :src="item.square_thumbnail" alt="">
                  <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                  <div class="stack">
                    <span class="title">{{item.title}}</span>
                  </div>
                </div>
              </td>
              <td class="placement none"><span>{{item.item_count}}</span></td>
              <td class="visibilty-action">
                <div class="visibilty-action__wrapper">
                  <div class="visibility">
                    <adx-selectdropdown :itemId="item.id" @selected="selected" :value.sync="item.status" :label="`Visibility`" :options="dropdown" />
                  </div>
                </div>
              </td>
              <td class="icon-list" v-if="type == `unselected`" @click.stop="addCollection(item)">
                <span>
                  <adx-loading-secondary v-if="isLoading.includes(item.id)" />
                  <i v-if="!isLoading.includes(item.id)" class="adx-ic_plus"></i>
                </span>
              </td>
              <td class="icon-list" v-if="type == `selected`" @click.stop="removeCollection(item)">
                <span>
                  <adx-loading-secondary v-if="isLoading.includes(item.id)" />
                  <i v-if="!isLoading.includes(item.id)" class="adx-ic_close"></i>
                </span>
              </td>
            </tr>
          </draggable>
          <tbody v-else>
            <tr v-for="(item, index) in items" :key="index" @click.stop="listClick(item)" class="content">
              <td class="items">
                <div class="item">
                  <img v-if="item.square_thumbnail" :src="item.thumbnail_square" alt="">
                  <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                  <div class="stack">
                    <span class="title">{{item.title}}</span>
                  </div>
                </div>
              </td>
              <td class="placement none"><span>{{item.item_count}}</span></td>
              <td class="visibilty-action">
                <div class="visibilty-action__wrapper">
                  <div class="visibility">
                    <adx-selectdropdown :itemId="item.id" @selected="selected" :value.sync="item.status" :label="`Visibility`" :options="dropdown" />
                  </div>
                </div>
              </td>
              <td class="icon-list" v-if="type == `unselected`" @click.stop="addCollection(item)">
                <span>
                  <adx-loading-secondary v-if="isLoading.includes(item.id)" />
                  <i v-if="!isLoading.includes(item.id)" class="adx-ic_plus"></i>
                </span>
              </td>
              <td class="icon-list" v-if="type == `selected`" @click.stop="removeCollection(item)">
                <span>
                  <adx-loading-secondary v-if="isLoading.includes(item.id)" />
                  <i v-if="!isLoading.includes(item.id)" class="adx-ic-close"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="emptyState">
          <adx-empty-selection v-if="isEmpty"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import LoadingSecondary from '@/components/Loading/Secondary'
import EmptySelection from '@/components/NotFound/Selection'
import draggable from 'vuedraggable'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-list-item-collection-editor',
  components: {
    'adx-selectdropdown': SelectDropdown,
    'adx-loading-secondary': LoadingSecondary,
    'adx-empty-selection': EmptySelection,
    draggable
  },
  props: {
    items: {
      required: false
    },
    headers: {
      required: false
    },
    category: {
      required: false
    },
    menuList: {
      required: false
    },
    page: {
      required: false
    },
    isAction: {
      required: false
    },
    loading: {
      required: false
    },
    title: {
      required: false
    },
    type: {
      required: false
    }
  },
  data() {
    return {
      isHover: null,
      isEmpty: false,
      lists: [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "S",
          "items": [
            {
              "name": "Create new saved"
            },
            {
              "name": "Saved Gaul"
            },
            {
              "name": "Saved Konser"
            },
            {
              "name": "Saved Nobar"
            },
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "AP",
          "items": [
            {
              "name": "Create new campaign"
            },
            {
              "name": "Gaul"
            },
            {
              "name": "Konser"
            },
            {
              "name": "Nobar"
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "KO"
        },
        {
          "id": 3,
          "name": "More from this brand",
          "value": "Mo"
        }
      ],
      saved: [],
      isLoading: [],
      dropdown: [
        {
          label: 'Public',
          value: 'Public'
        },
        {
          label: 'Private',
          value: 'Private'
        }
      ],
      listItems: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  beforeUpdate() {

  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    addCollection(item) {
      (async () => {
        const data = {
          collections_id: [item.id]
        }
        this.isLoading.push(item.id)
        const group_id = this.$route.params.id
        const response = await api.post(apiV2.collectionGroupAddCollection(group_id), data, { needToken: true })
        
        this.$emit('reloadData')
        this.isLoading = []
      })();
    },
    removeCollection(item) {
      (async () => {
        const group_id = this.$route.params.id
        const data = {
          group_id: group_id
        }
        this.isLoading.push(item.id)
        const response = await api.patch(apiV2.collectionRemoveFromGroup(item.id), data, { needToken: true })
        
        this.$emit('reloadData')
        this.isLoading = []
      })();
    },
    setID(id){

    },
    selected(item) {
      (async () => {
        const data = {
          id: item.id,
          visibility: item.item.value == 'Public' ? true : false
        }
        const response = await api.patch(apiV2.collectionDetail(item.id), data, { needToken: true })
        this.$notify({
          group: 'saved',
          title: 'Update Visibility Success',
          text: `${response.data.title} has been successfully changed to ${response.data.status}`,
          type: 'success'
        })
      })();
    },
    listClick(item) {
      this.$emit('item-clicked', item)
    },
    onEnd(evt) {
      (async () => {
        const group_id = this.$route.params.id
        const collections_id = this.items[evt.oldIndex].id

        const data = {
          group_id: parseInt(group_id),
          collection_id: collections_id,
          order: evt.newIndex + 1
        }

        const response = await api.patch(apiV2.collectionOrder, data, { needToken: true })

        this.$emit('orderChanged')

      })();
      
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>